import type { Document, Fragment } from '@gitbook/slate';

import { BLOCK_PARAGRAPH } from '../types';

/**
 * It considers empty any document containing no blocks
 * or an empty paragraph.
 */
export function isDocumentEmpty(document: Document | Fragment | undefined): boolean {
    if (!document) {
        return true;
    }

    const { nodes } = document;

    if (nodes.size === 0) {
        return true;
    }

    if (nodes.size > 1) {
        return false;
    }

    const paragraph = nodes.first();
    if (paragraph?.type !== BLOCK_PARAGRAPH) {
        return false;
    }

    return paragraph.isEmpty;
}
